import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-kentucky-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./kentucky-state-form.component.html",
  styleUrl: "./kentucky-state-form.component.scss",
})
export class KentuckyStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
